import {Component, Renderer2} from '@angular/core';
import {ToastService} from "../../../../core/services/toast.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../../core/services/common.service";
import {combineLatest as observableCombineLatest,  Observable } from 'rxjs';
import {HttpClientService} from "../../../../core/services/http-client.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  customer;
  customerId: any = 0;
  public loading: boolean = false;
  public user: any = {};

  loginMethod: string = 'password'; // 'password' or 'otp'

  otpSentForLogin: boolean = false;
  loginOtpValue: string = '';
  loginOtpReferenceId: string = '';

  otpRequested = true;
  visible: any;
  public otpValue: string = null;
  public verify: any = {};
  verified: boolean = false;
  otpSend: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private toast: ToastService,
    private route: ActivatedRoute,
    private _router: Router,
    public common: CommonService,
    private renderer: Renderer2,
    private http: HttpClientService,
  ){}

  ngOnInit() {
    observableCombineLatest([
      this.route.data,
      this.route.queryParams,
      this.route.params,
    ]).subscribe((bothParams) => {

      this.customerId = +bothParams[1].customerId;

      if (this.customerId > 0) {
        this.getCustomerById(this.customerId)
          .subscribe(data => {
            this.loading = false;
            if (data['responseStatus'].toLowerCase() == 'success') {
              this.customer = data['response'];
              this.user.mobile = this.customer.mobileNumber;
            }
          });
      }
    });
  }

  public usersignIn(params): Observable<any> {
    return this.http.post(`store/signin`, params);
  }

  public signInWithOtp(params): Observable<any> {
    return this.http.post(`store/signinWithOtp`, params);
  }

  public getCustomerById(id: Number): Observable<any> {
    return this.http.get(`store/getCustomerById/${id}`);
  }

  public generateOTP(params): Observable<any> {
    return this.http.get("store/otp/generateOTP", params);
  }

  public verifyuserOTP(params): Observable<any> {
    return this.http.get("otp/verifyOTP", params);
  }

  public resetuserPassword(params) {
    return this.http.post("store/resetPassword", params);
  }

  signIn() {
    this.loading = true;

    if (this.loginMethod === 'password') {
      this.signInWithPassword();
    } else if (this.loginMethod === 'otp') {
      this.signInWithOtpMethod();
    }
  }

  signInWithPassword() {

    this.usersignIn(this.user).subscribe(
      response => {
        this.loading = false;

        if (response?.responseStatus?.toLowerCase() === 'success') {

          this.getCustomerById(this.customerId).subscribe(data => {

            if (data?.responseStatus?.toLowerCase() === 'success') {
              this.customer = data.response;
              this.handleSuccessfulLogin();
            } else {
              this.toast.error("Could not fetch customer details");
            }
          });
        } else {
          this.toast.error("Could not logged in, password invalid");
          this.renderer.selectRootElement('#password').focus();
        }
      },
      error => {
        this.loading = false;
        this.toast.error("Something went wrong");
      }
    );
  }


  signInWithOtpMethod() {
    const otpLoginRequest = {
      mobile: this.user.mobile,
      otp: this.loginOtpValue,
      referenceId: this.loginOtpReferenceId
    };

    this.signInWithOtp(otpLoginRequest).subscribe(
      response => {
        this.loading = false;
        if (response?.responseStatus?.toLowerCase() === 'success') {
          this.getCustomerById(this.customerId).subscribe(data => {
            if (data?.responseStatus?.toLowerCase() === 'success') {
              this.customer = data.response;
              this.handleSuccessfulLogin();
            } else {
              this.toast.error("Could not fetch customer details");
            }
          });
        } else {
          this.toast.error("Invalid OTP. Please try again.");
        }
      },
      error => {
        this.loading = false;
        this.toast.error("Something went wrong with OTP verification");
      }
    );
  }


  requestLoginOtp() {
    if (!this.user.mobile) {
      this.toast.error("Please enter mobile number");
      return;
    }

    this.loading = true;
    const otpRequest = { mobile: this.user.mobile };

    this.generateOTP(otpRequest).subscribe(
      response => {
        this.loading = false;
        if (response.response && response.response.reference_id) {
          this.otpSentForLogin = true;
          this.loginOtpReferenceId = response.response.reference_id;
          this.toast.success("OTP sent successfully");
        } else {
          this.toast.error("Failed to send OTP");
        }
      },
      error => {
        this.loading = false;
        this.toast.error("Error sending OTP");
      }
    );
  }

  handleSuccessfulLogin() {
    this.common.setStorage('customer', this.customer);
    this.common.setLoggedIn(true);
    this.toast.success("You are successfully logged in");
    if(this.customer?.smartSeller){
      this._router.navigateByUrl("/associates/dashboard")
    }
    else
    this._router.navigate([this.common.getNavigteUrl()])
  }

  onLoginMethodChange() {
    this.otpSentForLogin = false;
    this.loginOtpValue = '';
    this.loginOtpReferenceId = '';
    this.user.password = '';
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  public requestOtp() {
    this.loading = true;
    delete this.user.password;
    this.generateOTP(this.user).subscribe(response => {
      this.otpRequested = false;
      this.otpSend = true;
      this.loading = false;
      this.verify['mobile'] = String(this.user.mobile);
      this.verify['referenceId'] = response.response.reference_id;
    });
  }

  public verifyOtp() {
    this.verify['otpCode'] = this.otpValue;
    this.verifyuserOTP(this.common.stringParams(this.verify)).subscribe(response => {
      if (response.response.result) {
        this.otpSend = false;
        this.verified = true;
      }
    });
  }

  resetPassword() {
    if (this.user.password !== this.user.confirmPassword) {
      this.toast.error("Passwords do not match");
      return;
    }

    if (this.user.password.length < 8) {
      this.toast.error("Password length should be at least 8 characters");
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
    if (!passwordRegex.test(this.user.password)) {
      this.toast.error(
        "Password must include at least one lowercase letter, one uppercase letter, and one number"
      );
      return;
    }

    this.loading = true;
    this.resetuserPassword(this.user).subscribe(
      (response) => {
        this.loading = false;
        if (response?.responseStatus?.toLowerCase() === "success") {
          this.toast.success("Password reset successful");
          this.common.setStorage("customer", this.customer);
          this.common.setLoggedIn(true);
          this.visible = false;
          this._router.navigate(['/login'], { queryParams: { customerId: this.customer.id } });
        } else {
          this.toast.error("Failed to reset password. Please try again.");
        }
      },
      (error) => {
        this.loading = false;
        this.toast.error("An error occurred while resetting the password");
      }
    );
  }

  back() {
    window.history.back();
  }

  goToPage(url): void {
    url = `/${url}`;
    this._router.navigateByUrl(url + "?customerId=" + this.customer.id);
  }

  register() {
    this._router.navigate(['/auth']);
  }
}
